import { RawAssignedServicePoint } from "@/entities/assignedServicePoint";

export type RawUserServicePoints = {
  readonly assignedServicePoints: RawAssignedServicePoint[];
};

export const iniRawUserServicePoints: RawUserServicePoints = {
  assignedServicePoints: Array.of(),
};
